export default __webpack_public_path__ + "static/media/REMOVE_.282e8c4b.png";